module.exports = "https://cdn.hellotech.com/client-assets/female-tech_528500b70262fd382408da6b50c0c038.png";